import { accountId } from '@gonfalon/constants/constants';

export function createCacheKey() {
  return `ld-query-cache-${accountId()}`;
}
